<template>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   width="16"
   height="16"
   class="bi bi-send-fill"
   viewBox="0 0 26 26"
   version="1.1"
   id="svg111"
   style="fill:currentColor">
  <defs
     id="defs115" />
  <path
     d="m 15.96475,1.0248829 a 0.5,0.5 0 0 0 -0.65,-0.65 l -14.54700046,5.819 h -0.001 l -0.452,0.18 a 0.5,0.5 0 0 0 -0.082,0.887 l 0.41,0.26 0.001,0.002 4.99499996,3.1780001 3.178,4.995 0.002,0.002 0.26,0.41 a 0.5,0.5 0 0 0 0.886,-0.083 z m -1.833,1.89 -7.4940005,7.4940001 -0.215,-0.338 a 0.5,0.5 0 0 0 -0.154,-0.154 l -0.338,-0.215 7.4940005,-7.4940001 1.178,-0.471 -0.47,1.178 z"
     id="outbound"
  />
  <path
     d="m 9.6294978,25.314195 a 0.5,0.5 0 0 0 0.6500002,0.65 l 14.547,-5.819 h 10e-4 l 0.452,-0.18 a 0.5,0.5 0 0 0 0.082,-0.886999 l -0.41,-0.26 -0.001,-0.002 -4.995,-3.178001 -3.178,-4.994999 -0.002,-0.002 -0.26,-0.41 a 0.5,0.5 0 0 0 -0.886,0.083 z m 1.8330002,-1.89 7.494,-7.494 0.215,0.338001 a 0.5,0.5 0 0 0 0.154,0.154 l 0.338,0.215 -7.494,7.493999 -1.178,0.471 0.47,-1.178 z"
     id="inbound"
  />
</svg>

</template>

<script>
// Built in Inkscape from 2 copies of https://icons.getbootstrap.com/icons/send-fill/
// Use css fill: #FFFFFF; with the #inbound and #outbound paths
export default {
  name: "Queued"
}
</script>

<style>

</style>